import { render, staticRenderFns } from "./card-weather.vue?vue&type=template&id=2f515824&scoped=true"
import script from "./card-weather.vue?vue&type=script&lang=js"
export * from "./card-weather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f515824",
  null
  
)

export default component.exports